import {
    FETCH_DEMOGRAPHIC_SELECTIONS,
    FETCH_DEMOGRAPHIC_SELECTIONS_FETCHING,
    FETCH_DEMOGRAPHIC_SELECTIONS_SUCCESS,
    FETCH_DEMOGRAPHIC_SELECTIONS_FAIL
} from 'actions/ActionTypes.js';

const INITIAL_STATE = {
    data: {},
    demographicSelectionsFetching: false,
    demographicSelectionsFetchFail: false
};

// ======= Fetching Handlers =======
const fetchDemographicSelectionsFetching = (state, action) => {
    return {
        data: state.data,
        demographicSelectionsFetching: true,
        demographicSelectionsFetchFail: false
    };
};

const fetchDemographicSelectionsSuccess = (state, action) => {
    return {
        data: action.data,
        demographicSelectionsFetching: false,
        demographicSelectionsFetchFail: false
    };
};

const fetchDemographicSelectionsFail = (state, action) => {
    return {
        data: state.data,
        demographicSelectionsFetching: false,
        demographicSelectionsFetchFail: true
    };
};

// ======= Handler Assignments =======
const handlers = {
    [FETCH_DEMOGRAPHIC_SELECTIONS_FETCHING]: fetchDemographicSelectionsFetching,
    [FETCH_DEMOGRAPHIC_SELECTIONS_SUCCESS]: fetchDemographicSelectionsSuccess,
    [FETCH_DEMOGRAPHIC_SELECTIONS_FAIL]: fetchDemographicSelectionsFail
};

// ======= Default Action =======
export default function demographicSelections(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function fetchDemographicSelections(lang, measurementSystem, evictCache) {
    return {
        type: FETCH_DEMOGRAPHIC_SELECTIONS,
        lang,
        measurementSystem,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getDemographicSelections = (state) => {
    return state.demographicSelections.data ? state.demographicSelections.data : null;
};

export const isDemographicSelectionsFetching = (state) => {
    return state.demographicSelections.demographicSelectionsFetching;
};

export const didDemographicSelectionsFetchFail = (state) => {
    return state.demographicSelections.demographicSelectionsFetchFail;
};
